/** @jsx jsx */
import { node, string } from 'prop-types'
import { Card, Text, Flex, jsx, Image } from 'theme-ui'

export const ContentCard = ({
  title,
  subTitle,
  imageUrl,
  imageDescription,
}) => (
  <Card
    id="letsgod"
    variant="newContent"
    sx={{
      minWidth: [350, 180, 200, 350],
      minHeight: [430, 420, 450, 370],
    }}
  >
    <Flex
      sx={{
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center',
        height: ['auto', 'auto', 'auto', 165],
        bg: '#DDDCDB', //this is a temp component so no need to add color to theme
      }}
    >
      <Image src={imageUrl} alt={imageDescription}></Image>
    </Flex>
    <Flex sx={{ pt: 5, px: 5, pb: 4 }}>
      <Text variant="h6">{title}</Text>
    </Flex>
    <Text variant="xxSmallText" as="h5" color="darkGray" sx={{ px: 5, pb: 64 }}>
      {subTitle}
    </Text>
  </Card>
)

ContentCard.propTypes = {
  subTitle: string.isRequired,
  imageUrl: node.isRequired,
  imageDescription: string.isRequired,
  title: string.isRequired,
}

export default ContentCard
